import { useTranslation } from "react-i18next";

import { DATE_FORMATS_FNS } from "components/DatePicker";
import { Note, ReplacementCarNote } from "components/Notes/DMSNotes/components";
import "components/Notes/DMSNotes/DMSNotes.scss";
import { APPOINTMENT_NOTE_TYPES } from "models";
import { formatDate } from "utils/dateHelperFunctions";

import type { AppointmentNote, CarNote } from "models";

type DMSNotesProps = {
  licensePlate?: string;
  dmsCarNotes?: CarNote[];
  dmsNotes?: AppointmentNote[];
};

export const DMSNotes = ({ dmsCarNotes, dmsNotes }: DMSNotesProps) => {
  const { t } = useTranslation();

  const getDmsNoteText = (note: string) => {
    if (!note.includes("replacement_vehicle")) return note;

    const text = note.replace("replacement_vehicle", "").trim();
    return `${t("v8_replacement_vehicle", "Replacement vehicle")} ${text}`;
  };

  const replacementCarNotes = dmsNotes?.filter(note => note.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.ReplacementVehicle);
  const dmsNotesWithoutReplacement = dmsNotes?.filter(note => note.appointment_note_type_id !== APPOINTMENT_NOTE_TYPES.ReplacementVehicle);

  return (
    <div className="DMSNotes">
      {replacementCarNotes?.map(({ note, created_on, id, rental_pickup_time, rental_drop_off_time, reg_nr }) => (
        <ReplacementCarNote
          pickupTime={rental_pickup_time ?? ""}
          dropOffTime={rental_drop_off_time ?? ""}
          licensePlate={reg_nr}
          note={note}
          timestamp={created_on && formatDate(created_on, DATE_FORMATS_FNS.dateMonthYearTime)}
          key={id}
        />
      ))}
      {dmsCarNotes?.map(({ note, created_on }: CarNote, idx) => (
        <Note key={`car-${idx}`} note={note} timestamp={created_on && formatDate(created_on, DATE_FORMATS_FNS.dateMonthYearTime)} isCarNote />
      ))}

      {dmsNotesWithoutReplacement?.map(({ note, created_on }, idx) => (
        <Note key={`note-${idx}`} note={getDmsNoteText(note)} timestamp={created_on && formatDate(created_on, DATE_FORMATS_FNS.dateMonthYearTime)} />
      ))}
    </div>
  );
};
